import request from '@/utils/request';
import { filterQuery } from '@/utils/index';


// getting inventories
export function getInventories(query) {
  return request({
    url: '/api/inventories/list',
    method: 'get',
    params: filterQuery(query)
  })
}

// getting inventories by item
export function getInventoriesByItem(id, query) {
  return request({
    url: `/api/inventories/list/item/${id}`,
    method: 'get',
    params: filterQuery(query)
  })
}

// getting inventory
export function getInventory(id) {
  return request({
    url: `/api/inventories/${id}`,
    method: 'get'
  })
}

// getting inventory imported items
export function getInventoryImportedItems(query) {
  return request({
    url: '/api/inventories/imported',
    method: 'get',
    params: filterQuery(query)
  })
}

// getting inventory found items
export function getInventoryFoundItems(query) {
  return request({
    url: '/api/inventories/found',
    method: 'get',
    params: filterQuery(query)
  })
}

// getting inventory imported items
export function getInventoryMissingItems(query) {
  return request({
    url: '/api/inventories/missing',
    method: 'get',
    params: filterQuery(query)
  })
}

// saving inventory
export function saveInventory(data) {
  return request({
    url: `/api/inventories/save`,
    method: 'post',
    data: data
  })
}

// importing inventory items
export function importItems(data){
  return request({
    url: `/api/inventories/import`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

// finding tags
export function doInventory(data){
  return request({
    url: `/api/inventories/doInventory`,
    method: 'post',
    data: data
  })
}

// finish inventory
export function doFinishInventory(data){
  return request({
    url: `/api/inventories/finishInventory`,
    method: 'post',
    data: data
  })
}

// export found inventory items
export function exportInventoryFoundItems(data){
  return request({
    url: '/api/inventories/exportFoundItems',
    method: 'post',
    data: data,
    //params: filterQuery(query),
    responseType: 'blob'
  })
}

// export missing inventory items
export function exportInventoryMissingItems(data){
  return request({
    url: '/api/inventories/exportMissingItems',
    method: 'post',
    //params: filterQuery(query),
    data: data,
    responseType: 'blob'
  })
}